import React from 'react';
import Image from 'next/image';
import StarImage from '@/assets/seo/star.png';

const Top = () => {
  return (
    <div className="relative w-full h-80 overflow-hidden flex items-center justify-center">
      <span
        className="pointer-events-none absolute w-[1370px] h-[1370px] -top-[202px] left-1/2 -translate-x-1/2 rounded-full"
        style={{
          background:
            'conic-gradient(from 150deg at 50% 46%, rgba(205,230,249,1) 0%, rgba(255,255,255,0) 83%)',
        }}
      />
      <span
        className="pointer-events-none absolute w-[1164px] h-[1164px] top-10 left-1/2 -translate-x-1/2 rounded-full"
        style={{
          background:
            'linear-gradient(180deg, rgba(254,248,244,1) 14%, rgba(255,255,255,0) 45%)',
        }}
      />
      <span
        className="pointer-events-none absolute w-[806px] h-[806px] top-[252px] left-1/2 -translate-x-1/2 rounded-full blur-sm"
        style={{
          background:
            'linear-gradient(180deg, rgba(236,220,255,0.45) 0%, rgba(255,255,255,0) 23%)',
        }}
      />

      <div className="flex items-center justify-center flex-col gap-4 z-10">
        <div className="flex items-center px-2 py-0.5 text-xs bg-web-blue-200 text-web-blue-500 rounded-lg">
          <Image
            src={StarImage}
            alt=""
            className="shrink-0 mr-1"
            width={12}
            height={12}
          />
          <span>基于 45,231 条薪资数据</span>
        </div>
        <h1 className="text-4.5xl font-semibold">
          整合全网招聘数据，为你提供全方位的薪资洞察
        </h1>
        <p className="text-xl text-web-grey-600">
          找到影响薪资的关键因素，规划你的职业发展路径
        </p>
      </div>
    </div>
  );
};

export default Top;
